import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { NavParams, ToastController, ViewController } from "ionic-angular";
import { isEmpty } from "lodash";
import { GenFormBuilder } from "../../../../providers/form";
import { Utilities } from "../../../../providers/utilities";
import { IQuestionAnswerPoll } from "../../../../shared/models/polls.model";

@Component({
  selector: "app-poll-form-question-answer",
  templateUrl: "question-answer-form.component.html",
})

export class PollFormQuestionAnswerComponent implements OnInit {

  public client: any;
  public pollId: string;
  public questionId: string;
  public languageMenu;
  public form: FormGroup;
  public submitAttempt: boolean = false;
  public answer: IQuestionAnswerPoll;

  constructor(
    private fb: FormBuilder,
    private genForm: GenFormBuilder,
    private utilities: Utilities,
    private toastController: ToastController,
    private navParams: NavParams,
    public viewCtrl: ViewController,
  ) { }

  public ngOnInit() {
    this.client = this.navParams.data.client;
    this.pollId = this.navParams.data.pollId;
    this.questionId = this.navParams.data.questionId;
    this.languageMenu = this.navParams.data.languageMenu;
    this.answer = this.navParams.data.answer;
    this.buildForm();
  }

  public patchForm() {
    if (this.answer !== undefined) {
    this.form.patchValue(this.answer);
    }
  }

  public onFormSubmitted({ value, valid }: { value: any, valid: boolean }) {
    this.submitAttempt = true;
    if (valid) {
      if (value.id !== null && value.id.length !== 0) {
        const obj = {};
        obj[value.id] = value;
        this.toastController.create({
          duration: 3000,
          message: "The answer was saved",
        }).present();
        this.viewCtrl.dismiss(obj);
      } else {
        value.id = this.utilities.generateRamdomKey();
        const obj = {};
        obj[value.id] = value;
        this.viewCtrl.dismiss(obj);
        this.toastController.create({
          duration: 3000,
          message: "The answer was saved",
        }).present();
      }
      this.form.reset();
      this.form.get("name").get("es").setValue("");
      this.form.get("name").get("en").setValue("");
      this.submitAttempt = false;
    } else {
      this.toastController.create({
        duration: 3000,
        message: "The form contains errors",
      }).present();
    }
  }

  private buildForm() {
    this.form = this.fb.group({});
    this.genForm.genInputString("id", this.form);
    this.genForm.genInputLang("name", this.form, this.client.defaultLanguage);
    this.patchForm();
  }
}



// WEBPACK FOOTER //
// ./src/pages/poll/components/question-answer-form/question-answer-form.component.ts